import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";

const TreeNode = ({ node, generateNodeProps, level = 0 }) => {
  const [expanded, setExpanded] = useState(node.expanded ?? true);
  const hasChildren = node.children && node.children.length > 0;
  const nodeProps = generateNodeProps ? generateNodeProps({ node }) : {};

  return (
    <div style={{ marginLeft: level * 20 }}>
      <div style={{ display: "flex", alignItems: "center", padding: "4px 0" }}>
        {hasChildren && (
          <span
            onClick={() => setExpanded(!expanded)}
            style={{ cursor: "pointer", marginRight: 8, userSelect: "none" }}
          >
            {expanded ? "▼" : "▶"}
          </span>
        )}
        {!hasChildren && <span style={{ marginRight: 8, width: 12 }} />}
        <span style={{ flex: 1 }}>{nodeProps.title || node.title || node.description}</span>
        {nodeProps.buttons}
      </div>
      {expanded && hasChildren && (
        <div>
          {node.children.map((child, idx) => (
            <TreeNode
              key={child.id || child.head || idx}
              node={child}
              generateNodeProps={generateNodeProps}
              level={level + 1}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const SimpleTree = ({ treeData = [], generateNodeProps, treeLoading }) => {
  if (treeLoading) return <p>Loading...</p>;
  if (!treeData || treeData.length === 0) return <p>No data</p>;

  return (
    <div style={{ fontFamily: "inherit", fontSize: 14 }}>
      {treeData.map((node, idx) => (
        <TreeNode
          key={node.id || node.head || idx}
          node={node}
          generateNodeProps={generateNodeProps}
        />
      ))}
    </div>
  );
};

SimpleTree.propTypes = {
  treeData: PropTypes.array,
  treeLoading: PropTypes.bool,
  generateNodeProps: PropTypes.func,
};

export default SimpleTree;

export const toggleExpandedForAll = ({ treeData, expanded = true }) => {
  const toggle = (nodes) =>
    nodes.map((node) => ({
      ...node,
      expanded,
      children: node.children ? toggle(node.children) : [],
    }));
  return toggle(treeData || []);
};
